import { config } from "@/config";
import { useAuthHeaders } from "@/hooks/use-auth-headers";
import { useQuery } from "@tanstack/react-query";
import type { Shape, Component, UnifiedResponse } from "@/types/diagram";
import { segregateShapesAndComponents } from "@/lib/utils";
import { apiFetch } from "@/lib/api-client";

export default function useGetShapesByCategoryService(
  id: string,
  enabled?: boolean
) {
  const { getAuthHeaders } = useAuthHeaders();

  const getShapesByCategory = async (): Promise<
    | {
        shapes: Shape[];
        components: Component[];
        total: number;
      }
    | undefined
  > => {
    const url = `${config.isometricApiUrl}/shapes/category/${id}`;

    try {
      const response = await apiFetch(url, {
        headers: getAuthHeaders(),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const shapesResp: { data: UnifiedResponse[]; total: number } =
        await response.json();
      const segregatedData = segregateShapesAndComponents(
        shapesResp?.data ?? []
      );
      return { ...segregatedData, total: shapesResp.total };
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  };

  return useQuery({
    queryKey: ["shapes-by-category", id],
    queryFn: getShapesByCategory,
    enabled: !!enabled && !!id,
  });
}
